import type { Dance } from "@recital-master/shared";
import { danceStyleLabel, formatDuration } from "@recital-master/shared";

import { joinWithDot } from "./format";

export function isRecitalIntro(dance: Dance): boolean {
  return dance.contentKind === "recital-intro";
}

export function danceMetaLine(dance: Dance): string {
  return isRecitalIntro(dance)
    ? joinWithDot(["Recital Intro", formatDuration(dance.durationSeconds)])
    : joinWithDot([
        danceStyleLabel(dance),
        dance.className,
        formatDuration(dance.durationSeconds)
      ]);
}
